export const MOTION_BOXES = 'mboxes'
export const MY_SELECTION = 'my-selection'
export const GOTO_KEY = 'goto-route'
